import { useSearchParams } from 'react-router-dom';

export const useSelectedCategoryParam = (): number | null => {
  const [searchParams] = useSearchParams();

  return searchParams.get('categories')
    ? Number(searchParams.get('categories'))
    : null;
};
